import HTTPHandler from 'lib/api/HTTPHandler'
import { LocalStorageService } from 'lib/utils/services/localStorage.service'
import { AUTH_API_URL, CAR_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class AuthService {
  static login = async data => {
    try {
      const result = await HTTPHandler.post(
        AUTH_API_URL + '/authenticate',
        data
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getUserById = async id => {
    try {
      const result = await HTTPHandler.get(
        AUTH_API_URL + '/users/getUsersById',
        {
          params: { userId: id }
        }
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getUsersByIIN = async iin => {
    try {
      const result = await HTTPHandler.get(
        AUTH_API_URL + '/users/getUsersByIIN/' + iin
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getUserByToken = async () => {
    try {
      const result = await HTTPHandler.get(
        AUTH_API_URL + '/users/getUserByToken'
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getUsers = async data => {
    try {
      const result = await HTTPHandler.post(
        AUTH_API_URL + '/users/getUsers',
        data
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static createUser = async data => {
    try {
      const result = await HTTPHandler.post(AUTH_API_URL + '/users', data)
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static updateUser = async data => {
    try {
      const result = await HTTPHandler.put(AUTH_API_URL + '/users', data)
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getDashboardReports = async () => {
    try {
      const result = await HTTPHandler.get(
        AUTH_API_URL + '/dictionary/dashboards'
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static updateUserDashboardCodes = async data => {
    try {
      const result = await HTTPHandler.put(
        AUTH_API_URL + '/users/updateDashboardCodes',
        data
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getReportsCodes = async () => {
    try {
      const result = await HTTPHandler.get(
        AUTH_API_URL + '/dictionary/reportCodes'
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static updateUserReportsCodes = async data => {
    try {
      const result = await HTTPHandler.get(
        AUTH_API_URL + '/users/updateReportCodes'
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getBranches = async () => {
    try {
      const result = await HTTPHandler.get(AUTH_API_URL + '/branches')
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getActiveProjects = async () => {
    try {
      const result = await HTTPHandler.get(AUTH_API_URL + '/projects/getActive')
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getRolesProject = async project => {
    try {
      const result = await HTTPHandler.get(AUTH_API_URL + '/roles/' + project)
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getSubdivisions = async () => {
    try {
      const result = await HTTPHandler.post(
        AUTH_API_URL + '/dictionary/subdivisions',
        { active: true }
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static blockUser = async (data = { id: '', isActive: false }) => {
    try {
      const result = await HTTPHandler.post(
        AUTH_API_URL + '/users/blockUser',
        data
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static getRolesUserById = async id => {
    try {
      const result = await HTTPHandler.get(AUTH_API_URL + '/roles/user/' + id)
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static deleteUserRole = async data => {
    try {
      const result = await HTTPHandler.post(
        AUTH_API_URL + '/users/removeRoleFromUser',
        data
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static addUserRole = async data => {
    try {
      const result = await HTTPHandler.post(
        AUTH_API_URL + '/users/addRoleToUser',
        data
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static changeUserPassword = async (username, newPassword) => {
    try {
      const result = await HTTPHandler.get(
        AUTH_API_URL + '/users/changePassword',
        {
          params: {
            username,
            newPassword
          }
        }
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }

  static uploadFile = async file => {
    try {
      const result = await HTTPHandler.post(
        CAR_API_URL + '/files/uploadFile',
        file
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }
  static setToken = token => {
    if (!!token) {
      LocalStorageService.setAccessToken(token)
      HTTPHandler.api.defaults.headers.Authorization = `Bearer ${token}`
    } else {
      LocalStorageService.removeAccessToken()
      delete HTTPHandler.api.defaults.headers.Authorization
    }
  }
}
